// This file autogenerated by generate-asset-types.js
// Do not modify it by hand. Any changes will be overwritten.
const sounds = {
  footstepSoft3: require("url:./audio/footstep-soft-3.flac"),
  footstepSoft2: require("url:./audio/footstep-soft-2.flac"),
  footstepSoft1: require("url:./audio/footstep-soft-1.flac"),
  footstepSlide: require("url:./audio/footstep-slide.flac"),
  footstepLoud2: require("url:./audio/footstep-loud-2.flac"),
  footstepLoud1: require("url:./audio/footstep-loud-1.flac"),
  cartImpact3: require("url:./audio/cart-impact-3.flac"),
  cartImpact2: require("url:./audio/cart-impact-2.flac"),
  cartImpact1: require("url:./audio/cart-impact-1.flac")
};
export type SoundName = keyof typeof sounds;

const images = {
  wallAo1: require("url:./images/wall-ao-1.png"),
  wall1: require("url:./images/wall-1.png"),
  tileFloor14: require("url:./images/tile-floor-14.jpg"),
  tileFloor13: require("url:./images/tile-floor-13.jpg"),
  orange: require("url:./images/orange.png"),
  favicon: require("url:./images/favicon.png"),
  editorGrid: require("url:./images/editor-grid.png"),
  demitriTorso: require("url:./images/demitri-torso.png"),
  demitriRightHand: require("url:./images/demitri-right-hand.png"),
  demitriRightArm: require("url:./images/demitri-right-arm.png"),
  demitriLeftHand: require("url:./images/demitri-left-hand.png"),
  demitriLeftArm: require("url:./images/demitri-left-arm.png"),
  demitriHead: require("url:./images/demitri-head.png"),
  cart: require("url:./images/cart.png"),
  cartWheel: require("url:./images/cart-wheel.png"),
  bathroomTileFloor1: require("url:./images/bathroom-tile-floor-1.png")
};
export type ImageName = keyof typeof images;

const fonts = {

};
export type FontName = keyof typeof fonts;

const levels = {

};
export type LevelName = keyof typeof levels;

const entityDefs = {
  orange: require("./entity-defs/orange.json")
}
export type EntityDefName = keyof typeof entityDefs;

const jsonBlobs = {

};

export const RESOURCES = { sounds, images, fonts, levels, entityDefs, jsonBlobs };
